import styled from "styled-components";

export const AddressCardWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0.75rem;
    gap: 0.75rem;
    
    border-radius: 1.25rem;
    border: 1.5px solid var(--Silver-100, #EDEDED);
    background: var(--Neutral-0, #FFF);
`;

export const AddressInfo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
`

export const TopDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`

export const Title = styled.h2`
    color: #000;
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.4rem;
`

export const AddressText = styled.p`
    align-self: stretch;
    color: var(--Neutral-500, #71717A);
    font-family: 'Inter', sans-serif;
    font-size: 0.875rem !important;
    font-style: normal;
    font-weight: 400;
    line-height: 1.4rem; /* 160% */
    padding-bottom: 0 !important;
`